export function removeItemFromSessionStorage(identificator, storageKey){
    let dataFromSessionStorage = (JSON.parse(sessionStorage.getItem(storageKey)) || []).filter( (data)=>{
        return data.identificator !== identificator ? data : null;
    });
    sessionStorage.setItem(storageKey, JSON.stringify(dataFromSessionStorage));
    return dataFromSessionStorage;
}

export function getSourceId() {
	return sessionStorage.getItem('source');
}

export function getReferrer() {
	return sessionStorage.getItem('referrer') || 'Unknown';
}
